"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fundAccountTypes = exports.paymentMethods = exports.transactionPurposes = exports.FundAccountStatus = exports.fundAccountStatuses = exports.PaymentGatewayProvider = exports.paymentGatewayProviders = exports.PaymentTransactionJobStatus = exports.paymentTransactionJobStatuses = exports.BulkTransactionStatus = exports.bulkTransactionStatuses = exports.TDSStatus = exports.tdsStatuses = exports.PaymentStatus = exports.paymentStatuses = void 0;
function enumFromConst(values) {
    return Object.fromEntries(values.map((v) => [v, v]));
}
exports.paymentStatuses = ['CREATED', 'PROCESSING', 'PROCESSED', 'FAILED'];
exports.PaymentStatus = enumFromConst(exports.paymentStatuses);
exports.tdsStatuses = ['PENDING', 'PROCESSED', 'FAILED'];
exports.TDSStatus = enumFromConst(exports.tdsStatuses);
exports.bulkTransactionStatuses = ['CREATED', 'ALL_REGISTERED', 'PARTIALLY_REGISTERED', 'NOT_REGISTERED'];
exports.BulkTransactionStatus = enumFromConst(exports.bulkTransactionStatuses);
exports.paymentTransactionJobStatuses = ['CREATED', 'PICKED', 'COMPLETED'];
exports.PaymentTransactionJobStatus = enumFromConst(exports.paymentTransactionJobStatuses);
exports.paymentGatewayProviders = ['ICICI', 'CASHFREE'];
exports.PaymentGatewayProvider = enumFromConst(exports.paymentGatewayProviders);
exports.fundAccountStatuses = ['CREATED', 'PENDING_VERIFICATION', 'VERIFIED', 'REJECTED', 'FAILED'];
exports.FundAccountStatus = enumFromConst(exports.fundAccountStatuses);
exports.transactionPurposes = ['PAYMENT', 'VERIFICATION'];
exports.paymentMethods = ['UPI', 'NEFT', 'IMPS', 'RTGS'];
exports.fundAccountTypes = ['BANK_ACCOUNT', 'VPA'];
//# sourceMappingURL=Payments.js.map